import { OptionType } from '@agro-club/agroclub-shared'
import { Address } from 'modules/domain/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AddressExtraInfo } from 'views/components/AddressTitle/AddressTitle'
import FormSelectShared, { FormSelectSharedProps } from '../../FormSelectShared'
import { WrapperFormControl } from '../styled'

const Option: FC<{ option: OptionType }> = ({ option }) => {
  const address = option.dto as Address
  return (
    <>
      <AddressExtraInfo address={address} />
      {address.address}
    </>
  )
}

const getLabel = (dto) => {
  return dto.address
}

export const AddressCommon: FC<FormSelectSharedProps> = ({ formik, fieldName, children, onChange, ...props }) => {
  const { t } = useTranslation()

  return (
    <>
      <WrapperFormControl>
        <FormSelectShared
          formik={formik}
          fieldName={fieldName}
          placeholder={t('bid:form.userAddressPlaceholder')}
          getLabel={getLabel}
          showSearch={false}
          simpleApiFormat
          OptionComponent={Option}
          onChange={onChange}
          {...props}
        >
          {children}
        </FormSelectShared>
      </WrapperFormControl>
    </>
  )
}
